export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  SELECTED_CATEGORY: "SELECTED_CATEGORY",
  INCREMENT_NOTIFICATION: "INCREMENT_NOTIFICATION",
  RESET_NOTIFICATION: "RESET_NOTIFICATION",
  SHOW_ORDER_COMPLETE_DIALOG: "SHOW_ORDER_COMPLETE_DIALOG",
};